(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-faq-section]');
    sections.forEach((section) => {
      if (section.dataset.faqBound === 'true') return;

      const triggers = section.querySelectorAll('[data-faq-toggle]');
      if (!triggers.length) return;

      const close = (answer, trigger) => {
        answer.classList.remove('is-open');
        answer.style.maxHeight = null;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      };

      const open = (answer, trigger) => {
        answer.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const answer = trigger.nextElementSibling;
          if (!answer) return;

          // Single-open accordion: close all others first.
          triggers.forEach((other) => {
            const otherAnswer = other.nextElementSibling;
            if (otherAnswer && otherAnswer !== answer) close(otherAnswer, other);
          });

          if (answer.classList.contains('is-open')) {
            close(answer, trigger);
          } else {
            open(answer, trigger);
          }
        });
      });

      // Auto-open the first item, or any item marked .is-open from server.
      const initial = section.querySelector('.faq-section__answer.is-open')
        || section.querySelector('.faq-section__answer');
      if (initial) {
        const initialTrigger = initial.previousElementSibling;
        open(initial, initialTrigger);
      }

      section.dataset.faqBound = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
